module.exports = __webpack_public_path__ + "static/media/ArrowRight.b2f4cc79.svg";